(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('AlertReceiversModalController', ["$scope", "$modalInstance", "$q", "avananUserDao", function ($scope, $modalInstance, $q, avananUserDao) {
        $scope.$on('$locationChangeStart', function () {
            $modalInstance.dismiss();
        });
        $scope.close = function () {
            $modalInstance.dismiss();
        };
        var sourceData;
        $scope.loading = true;
        $scope.model = {};
        $scope.users = [];
        $scope.warningMessage = '';
        $scope.errMsg = '';
        $scope.showWarningMsg = function () {
            if ($scope.users && $scope.users.length && !_($scope.model).find()) {
                $scope.warningMessage = 'You need to choose at least 1 user.';
                return true;
            } else if ($scope.errMsg) {
                $scope.warningMessage = $scope.errMsg;
                return true;
            }
            return false;
        };
        $scope.ok = function () {
            $scope.loading = true;
            $q.allSettled(_(sourceData).map(function (user) {
                if (user.send_alerts != $scope.model[user.id]) {
                    user.send_alerts = !!$scope.model[user.id];
                    return avananUserDao.update(user.id, user);
                }
            })).then(function (responses) {
                var errMsg = '', errCount = 0;
                $scope.errMsg = '';
                _(responses).each(function (res) {
                    if (res.state === 'rejected' && res.reason && res.reason.config && res.reason.config.data && res.reason.config.data.email) {
                        errCount++;
                        if (errMsg) {
                            errMsg += '<br/>Error ' + (!!$scope.model[res.reason.config.data.id] ? 'adding ' : 'removing ') + '<strong>' + res.reason.config.data.email + '</strong>';
                        } else {
                            errMsg = 'Error ' + (!!$scope.model[res.reason.config.data.id] ? 'adding ' : 'removing ') + '<strong>' + res.reason.config.data.email + '</strong>';
                        }
                    }
                });
                $scope.loading = false;
                if (errCount) {
                    $scope.errMsg = '<div class="red-text">' + errMsg + '</div>';
                } else {
                    $modalInstance.close();
                }
            });
        };
        avananUserDao.users().then(function (response) {
            sourceData = response.data.rows;
            _(response.data.rows).each(function (user) {
                $scope.model[user.id] = user.send_alerts || false;
                var displayName = _([
                    user.first_name,
                    user.last_name
                ]).compact().join(' ');
                if (!displayName) {
                    displayName = user.email;
                } else {
                    displayName += ' (' + user.email + ')';
                }
                $scope.users.push({
                    id: user.id,
                    label: displayName,
                    email: user.email
                });
            });
            $scope.users = _($scope.users).sortBy('email');
            $scope.loading = false;
        });
    }]);
    m.factory('alertReceiversModal', ["$modal", "path", function ($modal, path) {
        return {
            show: function (users, options) {
                var modalInstance = $modal.open({
                    templateUrl: path('gui-v2').ctrl('alert-receivers-modal').template(),
                    controller: 'AlertReceiversModalController',
                    backdrop: _(options).isObject() && !_(options.backdrop).isUndefined() ? options.backdrop : true,
                    keyboard: _(options).isObject() && !_(options.keyboard).isUndefined() ? options.keyboard : true
                });
                return modalInstance.result;
            }
        };
    }]);
}());